import { useLocation, useParams } from "react-router";

import { useGetEvent, useGetEventSuspense } from "@/api/bale";

export function useEventInviteCode() {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  return search.get("invite") ?? undefined;
}

export function useCurrentEvent<TData>(options: Parameters<typeof useGetEvent<TData>>[2]) {
  const params = useParams();
  const eventId = Number.parseInt(params.eventId!, 10);
  if (Number.isNaN(eventId)) {
    throw new TypeError("Page not found");
  }

  const invite = useEventInviteCode();
  return useGetEvent(eventId, { invite }, options);
}

export function useCurrentEventSuspense<TData>(options: Parameters<typeof useGetEventSuspense<TData>>[2]) {
  const params = useParams();
  const eventId = Number.parseInt(params.eventId!, 10);
  if (Number.isNaN(eventId)) {
    throw new TypeError("Page not found");
  }

  const invite = useEventInviteCode();
  return useGetEventSuspense(eventId, { invite }, options);
}
